import {AfterViewInit, Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-about-service',
  templateUrl: './about-service.component.html',
  styleUrls: ['./about-service.component.scss']
})
export class AboutServiceComponent implements OnInit, AfterViewInit {

  translatePath = 'public.about.'

  lookAbout: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  seeAbout() {
    this.lookAbout = !this.lookAbout
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

  }

}
